import { UpdateOrganizationInput } from '@buy-viasat/types/build/bv';
import api, { apiEndpoints } from 'shared/services/axios';

export type UpdateOrganizationRestInput = Omit<UpdateOrganizationInput, 'isTaxIdSsn' | 'isTaxExempt'> & {
  ssn: string | null;
};

export type UpdateOrganizationRestResponse = {
  updatedIndividualPartyId: string;
  updatedOrganizationPartyId: string;
};

export async function updateOrganizationRest(
  input: UpdateOrganizationRestInput,
): Promise<UpdateOrganizationRestResponse> {
  const response = await api.post<UpdateOrganizationRestResponse>(apiEndpoints.updateOrganization, input);
  return response.data;
}
